import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ResellerState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ResellerQuery extends QueryEntity<ResellerState> {

  constructor(protected store: Store) {
    super(store);
  }

}
